import React from 'react';
import { api_route, user_logout } from '../helpers/Global';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import FactureJournal from './FactureJournal';

class Factures extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            scrolling: true,
            facture_journal: false,
            selected_facture: "",
            count_factures: 0,
            btn_loading_text: '',
            time_param: '',
            refresh_data: 'init',
            page: 1,
            factures: [],
        }
        this.handleScroll = this.handleScroll.bind(this);
    }
    
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.componentDidUpdate();
    }
    
    
    componentDidUpdate() {
        var params = queryString.parse(this.props.location.search);
        var time_param = params.t;

        if (this.state.time_param !== time_param || this.state.refresh_data) {

            var page = this.state.page;
            var init_list = false;
            if (this.state.time_param !== time_param || this.state.refresh_data === 'init') {
                this.setState({ page: 1 });
                init_list = true;
                page = 1;
            }

            if (init_list && params.loader !== 'false') {
                this.props.loaderDisplay(true);
            }
          
            
            fetch(api_route('liste-factures') + '&page=' + page, { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                        this.props.loaderDisplay(false);
                    } else if (resp['liste-factures']) {

                        var count_factures = resp['total-factures'];
                        this.setState({
                            factures: (init_list ? resp['liste-factures'] : this.state.factures.concat(resp['liste-factures'])),
                            count_factures: count_factures
                        }, function () {

                            this.setState({
                                btn_loading_text: (this.state.factures.length !== count_factures ? 'Afficher plus' : null),
                            }, function () {
                                if (this.state.btn_loading_text && document.getElementById('btnLoadMore')) {
                                    document.getElementById('btnLoadMore').classList.remove('disabled');
                                }

                                if (resp['info-general']) {
                                    this.props.setLivreur(resp['info-general']);
                                }
                            });

                            this.props.loaderDisplay(false);
                        });
                    }
                })
               .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
            
            this.setState({
                time_param: time_param,
                refresh_data: false,
                scrolling: true,
            });

        }

        // back button 
        if (this.state.current_page !== this.props.current_page) {
            var facture_journal = this.state.facture_journal;
            if (this.props.current_page === 'list_factures') {
                facture_journal = false;
            }
            this.setState({
                current_page: this.props.current_page,
                facture_journal: facture_journal
            })
        }
    }
    
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    
    handleScroll() {
        if (this.state.scrolling) {
            const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
            const body = document.body;
            const html = document.documentElement;

            const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            const windowBottom = windowHeight + window.pageYOffset;
            if (windowBottom >= docHeight) {
                this.loadMore();
            }
        }
    }


    render() {
        if (this.state.facture_journal) {
            return (
                <FactureJournal
                    selected_facture={this.state.selected_facture}
                    setCurrentPage={this.props.setCurrentPage}
                    current_page={this.props.current_page}
                    loaderDisplay={this.props.loaderDisplay}
                    openErrorSystem={this.props.openErrorSystem}
                    
                />
            );
        }

        
        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity" style={{ height: 'auto' }}>
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">Mes Factures</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container">
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-header">
                                <h6>Liste des factures</h6>
                            </div>
                            <div className="card-body">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>{this.state.count_factures} Factures</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.factures.map((facture, indice) =>
                                            <React.Fragment key={indice + facture.facture_num}>
                                                <tr className="show-info-colis" onClick={() => this.showDetailsFacture(true, facture)}>
                                                    <td className="footable-first-visible p-relative">
                                                        <h6 className="d-inline-block vm" style={{ 'lineHeight': '22px', 'width': '90%', 'float': 'right' }}>
                                                            <span>{facture.facture_num}</span><br />

                                                            <small>{facture.created_at}</small><br />

                                                            <span className={`text-${facture.classstatut}`} style={{ 'fontSize': '14px' }}><strong>{facture.str_statut}</strong></span><br />

                                                           <br /><span className="font-weight-normal"><i className="material-icons ml-0 md-18">money</i>
                                                                {facture.str_total_credit} 
                                                            </span>
                                                        </h6>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )}

                                    </tbody>
                                </table>
                                {this.state.btn_loading_text && (
                                    <button type="button" id="btnLoadMore" className="btn btn-light btn-block" onClick={() => this.loadMore()}>{this.state.btn_loading_text}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
    
    showDetailsFacture = (v, facture) => {
        this.setState({
            selected_facture: facture,
            facture_journal: v,
            scrolling: false
        });
    }



    loadMore = () => {
        if (this.state.btn_loading_text) {
            const page = this.state.page + 1
            this.setState({
                page: page,
                refresh_data: true,
                btn_loading_text: 'Loading...'
            }, function () {
                var btn = document.getElementById('btnLoadMore');
                if (btn) btn.classList.add('disabled');
            });
        }
    }

}

export default withRouter(Factures);